import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
    Container, Paper, Table, TableBody, TableCell,
    TableContainer, TableHead, TableRow, IconButton,
    Button, Typography, Box, TextField, InputAdornment
} from '@mui/material';
import {
    Edit as EditIcon,
    Delete as DeleteIcon,
    Add as AddIcon,
    Search as SearchIcon,
    AccountBalance as AccountBalanceIcon
} from '@mui/icons-material';
import api from '../services/api';

function Advogados() {
    const navigate = useNavigate();
    const [advogados, setAdvogados] = useState([]);
    const [search, setSearch] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        loadAdvogados();
    }, []);

    const loadAdvogados = async () => {
        setLoading(true);
        try {
            const response = await api.get('/advogados');
            console.log('Advogados carregados:', response.data);
            setAdvogados(response.data || []);
        } catch (error) {
            console.error('Erro ao carregar advogados:', error);
            alert('Erro ao carregar advogados: ' + (error.response?.data?.error || error.message));
            setAdvogados([]);
        } finally {
            setLoading(false);
        }
    };

    const handleDelete = async (id) => {
        if (window.confirm('Tem certeza que deseja excluir este advogado?')) {
            try {
                await api.delete(`/advogados/${id}`);
                loadAdvogados();
            } catch (error) {
                console.error('Erro ao deletar advogado:', error);
                alert('Erro ao deletar advogado: ' + (error.response?.data?.error || error.message));
            }
        }
    };

    const advogadosFiltrados = advogados.filter(a => {
        if (!search) return true;
        const searchLower = search.toLowerCase();
        return (
            (a.nome && a.nome.toLowerCase().includes(searchLower)) ||
            (a.oab && a.oab.toLowerCase().includes(searchLower)) ||
            (a.email && a.email.toLowerCase().includes(searchLower))
        );
    });

    return (
        <Container>
            {/* Header destacado para indicar a tela ativa */}
            <Box 
                sx={{ 
                    mb: 3, 
                    p: 2, 
                    backgroundColor: 'primary.main', 
                    color: 'primary.contrastText',
                    borderRadius: 2,
                    boxShadow: 2
                }}
            >
                <Typography 
                    variant="h4" 
                    component="h1" 
                    sx={{ 
                        fontSize: { xs: '1.5rem', sm: '2rem' },
                        fontWeight: 600,
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1
                    }}
                >
                    <AccountBalanceIcon sx={{ fontSize: { xs: '1.5rem', sm: '2rem' } }} />
                    Advogados
                </Typography>
                <Typography variant="body2" sx={{ mt: 0.5, opacity: 0.9 }}>
                    Gerencie o cadastro de advogados
                </Typography>
            </Box>

            <Box sx={{ mb: 4, display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 2 }}>
                <Button
                    variant="contained"
                    startIcon={<AddIcon />}
                    onClick={() => navigate('/advogados/novo')}
                >
                    Novo Advogado
                </Button>
            </Box>

            <Box sx={{ mb: 3 }}>
                <TextField
                    fullWidth
                    placeholder="Buscar por nome, OAB ou email..."
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <SearchIcon />
                            </InputAdornment>
                        ),
                    }}
                />
            </Box>

            <TableContainer component={Paper}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Nome</TableCell>
                            <TableCell>OAB</TableCell>
                            <TableCell>Email</TableCell>
                            <TableCell>Telefone</TableCell>
                            <TableCell align="right">Ações</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {loading ? (
                            <TableRow>
                                <TableCell colSpan={5} align="center">Carregando...</TableCell>
                            </TableRow>
                        ) : advogadosFiltrados.length === 0 ? (
                            <TableRow>
                                <TableCell colSpan={5} align="center">
                                    {search ? 'Nenhum advogado encontrado' : 'Nenhum advogado cadastrado'}
                                </TableCell>
                            </TableRow>
                        ) : (
                            advogadosFiltrados.map((advogado) => (
                                <TableRow key={advogado.id} hover>
                                    <TableCell>{advogado.nome}</TableCell>
                                    <TableCell>{advogado.oab || '-'}</TableCell>
                                    <TableCell>{advogado.email || '-'}</TableCell>
                                    <TableCell>{advogado.telefone || '-'}</TableCell>
                                    <TableCell align="right">
                                        <IconButton 
                                            onClick={() => navigate(`/advogados/editar/${advogado.id}`)}
                                            color="primary"
                                            size="small"
                                        >
                                            <EditIcon />
                                        </IconButton>
                                        <IconButton 
                                            onClick={() => handleDelete(advogado.id)}
                                            color="error"
                                            size="small"
                                        >
                                            <DeleteIcon />
                                        </IconButton>
                                    </TableCell>
                                </TableRow>
                            ))
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
        </Container>
    );
}

export default Advogados;

